import React from 'react';

const features = [
  {
    title: 'Risk Calculator + Risk Engine',
    description:
      'Use the core Risk Calculator to size trades, then unlock premium Risk Engine feedback for score-based trade evaluation and clearer decision support.',
  },
  {
    title: 'Trade Journaling',
    description:
      'Log trades, review patterns, and build stronger discipline through a cleaner journaling workflow designed for consistency.',
  },
  {
    title: 'Unified Overview',
    description:
      'Bring your calculations, journaling, and performance context into one place so your workflow feels connected, organized, and actionable.',
  },
];

const Features = () => {
  return (
    <section className="py-20 bg-[#121212] text-[#e0e0e0] px-4">
      <div className="max-w-6xl mx-auto text-center">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">
          Built for focused traders
        </p>

        <h2 className="text-2xl md:text-4xl font-bold mb-4 tracking-tight text-white">
          A Cleaner Trading Workflow.
        </h2>

        <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto mb-10 leading-8">
          FlowQuant is being shaped to help traders stay organized, evaluate
          risk more clearly, and turn daily execution into a more structured
          process.
        </p>

        <div className="grid gap-5 md:grid-cols-3">
          {features.map((feature, index) => (
            <div
              key={index}
              className="rounded-2xl border border-white/10 bg-[#171717] p-5 text-left shadow-lg transition duration-200 hover:-translate-y-1"
            >
              <h3 className="text-lg font-semibold mb-3 text-white">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-400 leading-7">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;